export const ORGANIZATION_ID = "o4795742339.sdIn2NQi8iF9RWe7"; // smart-recruit | o4795742339.sdIn2NQi8iF9RWe7
